module.exports = __webpack_public_path__ + "static/media/FAMILIASOLAR.42ba02c7.pdf";